<template>
  <div class="privacy-page">
    <div class="privacy-container">
      <h1>Privacy Policy</h1>
      <p class="effective-date">Effective Date: March 24, 2026</p>

      <section>
        <h2>Information We Collect</h2>
        <p>
          When you submit a quote request, we collect the information you provide,
          including your name, email, phone, city, state, project type, timeline,
          message, and any optional attachments.
        </p>
      </section>

      <section>
        <h2>How We Use Information</h2>
        <p>
          We use your information to review your project request, contact you,
          provide estimates, and follow up about services.
        </p>
      </section>

      <section>
        <h2>Third-Party Services</h2>
        <p>
          We use Google reCAPTCHA to protect our form from abuse. reCAPTCHA may
          collect device and interaction data subject to Google&apos;s Privacy Policy
          and Terms.
        </p>
      </section>

      <section>
        <h2>Storage and Security</h2>
        <p>
          Quote requests are processed through our backend and email system. We
          apply reasonable measures to protect submitted information.
        </p>
      </section>

      <section>
        <h2>Cookies and Browser Storage</h2>
        <p>
          Our public quote page does not use first-party cookies in application
          code. Our admin area uses browser local storage for authentication state,
          and reCAPTCHA may set cookies through Google services.
        </p>
      </section>

      <section>
        <h2>Your Choices</h2>
        <p>
          To request updates or deletion of your submitted quote information,
          contact us at abel@2gnconstruction.com.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          If you have questions about this policy, contact us at
          abel@2gnconstruction.com.
          Business Entity No: 12126782-0610
        </p>
      </section>

      <a class="back-link" href="#home">← Back to Home</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  background: #f8f9fa;
  padding: 3rem 1rem;
  color: #1f2937;
}

.privacy-container {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

h1 {
  margin-bottom: 0.25rem;
  font-size: 2rem;
}

.effective-date {
  color: #6b7280;
  margin-bottom: 1.5rem;
}

section {
  margin-bottom: 1.25rem;
}

h2 {
  font-size: 1.15rem;
  margin-bottom: 0.5rem;
  color: #111827;
}

p {
  line-height: 1.65;
  color: #374151;
}

.back-link {
  display: inline-block;
  margin-top: 1rem;
  color: #ff6b35;
  text-decoration: none;
  font-weight: 600;
}

.back-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .privacy-container {
    padding: 1.25rem;
  }

  h1 {
    font-size: 1.6rem;
  }
}
</style>